module.exports = __webpack_public_path__ + "static/media/hoverTelegram.aef0dec9.svg";